import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      metrics: [],
      reference: null,
      headers_1_0: [
        { key: 17, name: '在籍合計', type: 'header', id: 'TTL', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      headers_1_1: [
        { key: 14, name: '小学部在籍', type: 'header', id: 'S', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 1, name: '小1', type: 'S', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 2, name: '小2', type: 'S', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 3, name: '小3', type: 'S', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 4, name: '小4', type: 'S', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 5, name: '小5', type: 'S', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 6, name: '小6', type: 'S', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 15, name: '中学部在籍', type: 'header', id: 'J', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 7, name: '中1', type: 'J', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 8, name: '中2', type: 'J', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 9, name: '中3', type: 'J', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 16, name: '高校部在籍', type: 'header', id: 'H', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 10, name: '高1', type: 'H', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 11, name: '高2', type: 'H', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 12, name: '高3', type: 'H', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      headers_1_2: [
        { key: 13, name: '既卒', type: 'H', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      headers_1_extension_0_0: [
        { key: 0, name: '幼児在籍', type: 'header', id: 'P', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      headers_1_extension_1_0: [
        { key: 30, name: '幼児部在籍', type: 'header', id: 'Y', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 26, name: '3歳', type: 'Y', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 27, name: '4歳', type: 'Y', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 28, name: '5歳', type: 'Y', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 29, name: '6歳', type: 'Y', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      headers_1_extension_1_1: [
        { key: 13, name: '社会人', type: 'H', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      headers_2_0: [
        { key: 17, name: '入退合計', type: 'header', id: 'TTL', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      headers_2_1: [
        { key: 14, name: '小学部入退', type: 'header', id: 'SI', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 1, name: '小1', type: 'SI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 2, name: '小2', type: 'SI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 3, name: '小3', type: 'SI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 4, name: '小4', type: 'SI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 5, name: '小5', type: 'SI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 6, name: '小6', type: 'SI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 15, name: '中学部入退', type: 'header', id: 'JI', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 7, name: '中1', type: 'JI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 8, name: '中2', type: 'JI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 9, name: '中3', type: 'JI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 16, name: '高校部入退', type: 'header', id: 'HI', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 10, name: '高1', type: 'HI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 11, name: '高2', type: 'HI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 12, name: '高3', type: 'HI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      headers_2_2: [
        { key: 13, name: '既卒', type: 'HI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      headers_2_extension_0: [
        { key: 0, name: '幼児入退', type: 'header', id: 'PI', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      headers_2_extension_1_0: [
        { key: 30, name: '幼児部入退', type: 'header', id: 'YI', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 26, name: '3歳', type: 'YI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 27, name: '4歳', type: 'YI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 28, name: '5歳', type: 'YI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 29, name: '6歳', type: 'YI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      headers_2_extension_1_1: [
        { key: 13, name: '社会人', type: 'HI', sufix: '人', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ]
    }
  },
  getters: {
    metrics (state) {
      return state.metrics
    },
    reference (state) {
      return state.reference
    },
    headers (state) {
      var headers = []
      var preschool = store.getters['shared/preschool']
      var extension = store.getters['shared/extension']
      if (preschool) {
        if (extension === 1) {
          headers = headers.concat(state.headers_1_0) // 在籍合計
          headers = headers.concat(state.headers_1_extension_1_0) // 幼児
          headers = headers.concat(state.headers_1_1)
          headers = headers.concat(state.headers_1_extension_1_1) // 幼児
          return headers
        } else {
          headers = headers.concat(state.headers_1_0) // 在籍合計
          headers = headers.concat(state.headers_1_extension_0_0) // 幼児
          headers = headers.concat(state.headers_1_1)
          headers = headers.concat(state.headers_1_2)
        }
      } else {
        headers = headers.concat(state.headers_1_0) // 在籍合計
        headers = headers.concat(state.headers_1_1)
        headers = headers.concat(state.headers_1_2)
      }
      return headers
    },
    headers2 (state) {
      var headers = []
      var preschool = store.getters['shared/preschool']
      var extension = store.getters['shared/extension']
      if (preschool) {
        if (extension === 1) {
          headers = headers.concat(state.headers_2_0) // 在籍合計
          headers = headers.concat(state.headers_2_extension_1_0) // 幼児
          headers = headers.concat(state.headers_2_1)
          headers = headers.concat(state.headers_2_extension_1_1) // 幼児
          return headers
        } else {
          headers = headers.concat(state.headers_2_0) // 在籍合計
          headers = headers.concat(state.headers_2_extension_0) // 幼児
          headers = headers.concat(state.headers_2_1)
          headers = headers.concat(state.headers_2_2)
        }
      } else {
        headers = headers.concat(state.headers_2_0) // 在籍合計
        headers = headers.concat(state.headers_2_1)
        headers = headers.concat(state.headers_2_2)
      }
      return headers
    }
  },
  mutations: {
    init (state, payload) {
      state.metrics = payload
    },
    add (state, payload) {
      state.metrics.push(payload)
    },
    update (state, payload) {
      const index = state.metrics.findIndex(metric => metric.key === payload.key)
      if (index !== -1) {
        Vue.set(state.metrics, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.metrics.findIndex(metric => metric.key === payload.key)
      if (index !== -1) {
        state.metrics.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }, payload) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('metrics_acts')
        var reference = null
        if (payload) {
          reference = dbRef.where('schools.' + payload, '==', true).onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        } else {
          reference = dbRef.onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        }
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['metricsActs/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    },
    write ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        var ref = null
        if (payload.key) {
          ref = db.collection('metrics_acts').doc(payload.key)
        } else {
          ref = db.collection('metrics_acts').doc()
          payload.key = ref.id
        }
        ref.set(payload)
          .then(function () {
            const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
            pause(0).then(() => {
              console.log('Document successfully written!')
              resolve()
            })
          })
          .catch(function (error) {
            console.error('Error writing document: ', error)
            resolve()
          })
      })
    },
    delete ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        db.collection('metrics_acts').doc(payload).delete().then(function () {
          console.log('Document successfully deleted!')
          resolve()
        }).catch(function (error) {
          console.error('Error removing document: ', error)
          resolve()
        })
      })
    }
  }
}
